module.exports = __webpack_public_path__ + "static/img/about-banner-bg-01.bef3bc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-banner-bg-01.png
// module id = XbNe
// module chunks = 1